import React from 'react';
import IscilikHesap from '../components/Iscilik/IscilikHesap';
import './IscilikAlacaklariHesap.css';

const IscilikAlacaklariHesap = () => (
  <div className="ia-page">
    <div className="page-header ia-header">
      <div>
        <h1>İşçilik Alacakları Hesapla</h1>
        <p className="ia-header-sub">
          Kıdem, ihbar, yıllık izin, fazla mesai, UBGT ve hafta tatili · 2026 parametreleri
        </p>
      </div>
    </div>
    <IscilikHesap />
  </div>
);

export default IscilikAlacaklariHesap;
